import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { social } from "../config/site";

const Social = () => {
  if (social.length === 0) return null;

  return (
    <div className="share">
      <ul className="social">
        {social.map((item) => (
          <li key={item.link}>
            <a
              href={item.link}
              target="_blank"
              rel="noreferrer"
              aria-label={item.label}
            >
              <FontAwesomeIcon
                icon={item.icon}
                style={{ width: "24px", height: "24px" }}
              />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Social;
